<template>
    <div id="form-id">
        <div class="type-box">
            <div>
                <el-select v-model="tempValue" @change="changeStatType" size="mini">
                    <el-option v-for="(item,index) in modeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span style="padding-left:20px"></span>
                <el-checkbox v-if="statType!=10" v-model="openTimer" @change="changeTimer">60s刷新一次</el-checkbox>
            </div>
            
            <el-date-picker
                v-if="statType!=5&&statType!=9&&statType!=10"
                style="width:320px"
                v-model="filterbox.time"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                @change="changeShowTime"
                align="right">

            </el-date-picker>
        </div>
        <StatOrder ref="stat" v-if="statType==1" :filterbox="filterbox" style="padding:10px"></StatOrder>
        <StatPayment ref="stat" v-else-if="statType==2" :filterbox="filterbox" style="padding:10px"></StatPayment>
        <StatStock ref="stat" v-else-if="statType==3" :filterbox="filterbox" style="padding:10px"></StatStock>
        <StatPiece ref="stat" v-else-if="statType==4" :filterbox="filterbox" style="padding:10px"></StatPiece>
        <StatOffice ref="stat" v-else-if="statType==5" style="padding:10px"></StatOffice>
        <StatPurchase ref="stat" v-else-if="statType==6" :filterbox="filterbox" style="padding:10px"></StatPurchase>
        <StatCustomer ref="stat" v-else-if="statType==7" :filterbox="filterbox" style="padding:10px"></StatCustomer>
        <StatOther ref="stat" v-else-if="statType==9" style="padding:10px"></StatOther>
        <StatPlatform ref="stat" v-else-if="statType==10"></StatPlatform>
    </div>
</template>

<script>
import StatOrder from './order/index.vue';
import StatPayment from './payment/index.vue';
import StatStock from './stock/index.vue';
import StatPiece from './piece/index.vue';
import StatPurchase from './purchase/index.vue';
import StatOffice from './office/index.vue';
import StatCustomer from './customer/index.vue';
import StatOther from './other/index.vue';
import StatPlatform from './platform/index.vue';
export default {
    components:{
        StatOrder,
        StatPayment,
        StatStock,
        StatPiece,
        StatOffice,
        StatPurchase,
        StatCustomer,
        StatOther,
        StatPlatform,
    },
    data(){
        return{
            statType:-1,
            tempValue:-1,
            bb:false,
            modeList:[{
                label:'订单',
                value:1,
            },{
                label:'财务',
                value:2,
            },{
                label:'库存',
                value:3,
            },{
                label:'计件',
                value:4,
            },{
                label:'办公',
                value:5,
            },{
                label:'采购',
                value:6,
            },{
                label:'客户',
                value:7,
            },{
                label:'其他',
                value:9,
            }],
            filterbox:{
                time:'',
            },
            openTimer:false,
            timerOption:null,
            pickerOptions: {shortcuts:this.$common.initPickerOptions()},
        }
    },
    created(){
        if(this.$global.rank==1){
            this.modeList.push({
                label:'顺通ERP大数据平台',
                value:10,
            })
        }
        let year = new Date().getFullYear();
        let start = year+'-01-01 00:00:00';
        let end = year+'-12-31 23:59:59';
        this.filterbox.time = [start,end];
        let type = this.$route.query.type;
        if(type>0){
            this.tempValue = Number.parseInt(type);
        }else{
            this.tempValue = 1;
        }
        this.changeStatType();
        window.addEventListener('resize',this.setResize); 
    },
    mounted(){
    },
    beforeDestroy(){
        if(this.statType>0){
            this.$refs.stat.close();
        }
        if(this.timerOption){
            clearInterval(this.timerOption);
            this.timerOption = null;
        }
        window.removeEventListener('resize',this.setResize);
    },
    methods:{
        changeTimer(){
            if(this.openTimer){
                if(!this.timerOption){
                    this.timerOption = setInterval(()=>{
                        this.changeShowTime();
                    },60000)
                    this.$common.success('开启刷新');
                }
            }else{
                if(this.timerOption){
                    clearInterval(this.timerOption);
                    this.timerOption = null;
                    this.$common.success('关闭刷新');
                }
            }
        },
        setResize(){
            this.bb=!this.bb;
            if(this.bb){
                this.$refs.stat.setResize();
            } 
        },
        changeStatType(){
            if(this.statType==this.tempValue){
                return;
            }
            if(this.statType>0){
                this.$refs.stat.close();
            }
            this.statType = this.tempValue;
            this.$nextTick(()=>{
                this.$refs.stat.init();
            })
        },
        changeShowTime(){
            if(this.statType!=10){
                return;
            }
            if(this.filterbox.time&&this.filterbox.time.length==2){
                if(typeof(this.filterbox.time[0])!='string'){
                    this.filterbox.time[0] = this.$common.formats(this.filterbox.time[0]);
                    this.filterbox.time[1] = this.$common.formats(this.filterbox.time[1]);
                }
            }
            this.$refs.stat.init();
        }
    }
    
}
</script>

<style scoped lang="scss">
.type-box{
    padding:15px 10px;
    display:flex;
    background-color: #f0f2f7;
    justify-content: space-between;
}

</style>
<style lang="less">
.sp-card{
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    transition: .3s;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 #E6E6E6;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    .title{
        font-size: 16px;
        line-height: 20px;
        font-weight: bold;
        color: #000;
    }
    .mainNumber{
        line-height:60px;
        font-size:20px;
        color:#000;
        font-weight: bold;
    }
    .other{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        height: 40px;
        .key{
            color: #A3A3A3;
            padding-right: 5px;
            font-size: 12px;
            line-height: 20px;
        }
        .value{
            color:#000;
            font-size: 14px;
            line-height: 20px;
        }
    }
    .img{
        width: 60px;
        height: 60px;
        position: absolute;
        top: 30px;
        right: 0px;
    }
    .filter-box{
        position: absolute;
        top: 10px;
        right: 10px;
    }
}
</style>